export default function AdaptOrganizationNo(organizationNumber: string): string {
    if (organizationNumber.indexOf('-') == -1 && organizationNumber.length == 10) {
        organizationNumber = organizationNumber.substring(0, 6) + '-' + organizationNumber.substr(6)
    }
  
    return organizationNumber;
} 